import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ModalController, NavParams } from '@ionic/angular';
import { ApiJwtService } from 'src/app/services/api-jwt.service';
import { IadeKosullariPage } from '../iade-kosullari/iade-kosullari.page';
import { MesafeliSatisSozlesmesiPage } from '../mesafeli-satis-sozlesmesi/mesafeli-satis-sozlesmesi.page';

@Component({
  selector: 'app-checkout-iyzico',
  templateUrl: './checkout-iyzico.page.html',
  styleUrls: ['./checkout-iyzico.page.scss'],
})
export class CheckoutIyzicoPage implements OnInit {

  mesafeliSatisSozlesmesiKontrol = true;
  teslimatVeIadeKontrol = true;
  path: any;
  accountId: any;
  proileId: any;
  expertName: any;
  price: any;


  name: string;
  surname: string;
  address: string;
  email: string;
  zipCode: string;
  country: string;
  city: string;
  gsm: string;
  identifyNumber: string;
  cardName: string;
  cardNumber: any;
  cardMonth: any;
  cardYear: any;
  cardCvv: any;
  constructor(private modalController: ModalController,
              private navParams: NavParams,
              private apiJwtService: ApiJwtService,
              private afAuth: AngularFireAuth,
              private firestore: AngularFirestore) { }

  ngOnInit() {
    this.path = this.navParams.get('path');
    this.accountId = this.navParams.get('accountId');
    this.proileId = this.navParams.get('proileId');
    this.expertName = this.navParams.get('expertName');
    this.price = this.navParams.get('price');
  }

  openMesafeliSatis() {
    this.modalController.create({ component: MesafeliSatisSozlesmesiPage, id: 'MesafeliSatis' }).then((modalElement) => {
      modalElement.present();
    }
    );
  }

  openIadeKosullari() {
    this.modalController.create({ component: IadeKosullariPage, id: 'IadeKosullari' }).then((modalElement) => {
      modalElement.present();
    }
    );
  }


  dismiss() {
    this.modalController.dismiss();
  }

  checkout() {
    const bItems: any[] = [];
    this.afAuth.onAuthStateChanged(user => {
      if (user && user.uid) {
        bItems.push({
          ref: this.accountId,
          obj: {
            id: user.uid,
            Name: 'Online Danışma Hizmeti',
            Category: 'Online Görüşme',
            category2: 'Danışmanlık',
            itemType: '',
            Price: this.price,
            Amount: 1
          }
        });
        const convId = this.firestore.createId();
        this.apiJwtService
        .createUpdateDelete('https://europe-west3-drwho-275812.cloudfunctions.net/iyzico_order_create', {
          callback: `https://europe-west3-drwho-275812.cloudfunctions.net/iyzico_order_confirm?conversationId=${convId}`,
          conversationId: '1234',
          price: this.price,
          name: this.name,
          surname: this.surname,
          email: this.email,
          address: this.address,
          identityNumber: this.identifyNumber,
          contactName: this.name + ' ' + this.surname,
          gsmNumber: this.gsm,
          city: this.city,
          country: this.country,
          zipCode: this.zipCode,
          cardHolderName: 'Akbank - Mater Card Debit',
          cardNumber: this.cardNumber,
          expireMonth: this.cardMonth,
          expireYear: this.cardYear,
          cvc: this.cardCvv,
          registeredCard: '0',
          basketItems: bItems,
          userID: user.uid,
          iyziPayApiKey: '',
          iyziPayApiSecret: '',
        }).then((response: any) => {
          if (response.status === 'success') {
            const paymentPage = response.payWithIyzicoPageUrl;
            window.location.href = paymentPage;
          } else {
            console.log(response.status);
            console.log(response);
          }
        }).catch(err => {
          console.log(err.response);
          console.log(err);
        });
      }
    });
  }


}
